import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "text-sm"
};
import { generateColorMap } from "@/modules/vue/utils";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleActionSheetItem',
  props: {
    disabled: {
      type: Boolean
    },
    icon: null,
    color: null,
    to: null,
    hideOnClick: {
      type: Boolean
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const colorClassMap = generateColorMap({
      text: 700
    });
    const hide = inject('hide');
    const show = inject('show');
    const toggle = inject('toggle');
    const router = useRouter();
    const onClick = e => {
      if (props.disabled) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (props.to) {
        hide();
        router.push(props.to);
      }
      if (props.hideOnClick) {
        hide();
      }
    };
    expose({
      show,
      hide,
      toggle
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex-col items-center justify-center w-full p-4 text-lg text-center border-b last:border-b-0", {
          'opacity-50 cursor-not-allowed': __props.disabled,
          'cursor-pointer active:bg-gray-200 ': !__props.disabled
        }]),
        onClickCapture: onClick
      }, [_createElementVNode("div", {
        class: _normalizeClass([_unref(colorClassMap)[__props.color] ?? null, "flex-center"])
      }, [__props.icon ? (_openBlock(), _createBlock(Icon, {
        key: 0,
        icon: __props.icon,
        class: "mr-2"
      }, null, 8, ["icon"])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")], 2), _ctx.$slots.description ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "description")])) : _createCommentVNode("", true)], 34);
    };
  }
});